import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'parcels-edit-service' });

export const { update, reducer } = actions;

export default reducer;
